import {
  DETACHED_HOUSE,
  APARTMENT_HOUSE
} from '@/modules/buildings/common/types.js';

export default {
  computed: {
    buildingTypes() {
      return [
        { id: DETACHED_HOUSE, name: this.$t('BUILDINGS.DETACHED_HOUSE') },
        { id: APARTMENT_HOUSE, name: this.$t('BUILDINGS.APARTMENT_HOUSE') }
      ];
    }
  },

  methods: {
    getHouseType(id) {
      return this.buildingTypes.find(i => i.id === id);
    }
  }
};
